module.exports = __webpack_public_path__ + "static/media/pull-ups.007e08c7.svg";